function getDefaultState() {
  return {
    token: localStorage.getItem("token") || "",
    user: {
      name: localStorage.getItem("nome") || ""
    },
    acessos: [],
    grupo_compras: "1",
    grupos: [],
    filial_compras: "0",
    exibeFilialCompra: false
  };
}

const state = getDefaultState();

const getters = {
  getToken(state) {
    return state.token;
  },

  getAcessos(state) {
    return state.acessos;
  },

  getUser(state) {
    return state.user;
  },
  getGrupoCompras(state) {
    return state.grupo_compras;
  },
  getGrupos(state) {
    return state.grupos;
  },
  getFilialCompras(state) {
    return state.filial_compras;
  },
  getExibeFilialCompra(state) {
    return state.exibeFilialCompra;
  }
};

const mutations = {
  setToken(state, token) {
    state.token = token;
  },

  setAcessos(state, acesso) {
    state.acessos = acesso;
  },

  setUser(state, user) {
    state.user = user;
  },
  setGrupoCompras(state, grupo) {
    state.grupo_compras = grupo;
  },
  setGrupos(state, grupo) {
    state.grupos = grupo;
  },
  setFilialCompras(state, filial) {
    state.filial_compras = filial;
  },
  setExibeFilialCompra(state, resp) {
    state.exibeFilialCompra = resp;
  }
};

const actions = {
  setToken: ({ commit }, token) => {
    commit("setToken", token);
  },
  setNome: ({ commit }, nome) => {
    commit("setUser", nome);
  },
  setAcessos: ({ commit }, acessos) => {
    commit("setAcessos", acessos);
  },
  setGrupoCompras: ({ commit }, grupo) => {
    commit("setGrupoCompras", grupo);
  },
  setGrupos: ({ commit }, grupo) => {
    commit("setGrupos", grupo);
  },
  setFilialCompras: ({ commit }, filial) => {
    commit("setFilialCompras", filial);
  },
  setExibeFilialCompra: ({ commit }, resp) => {
    commit("setExibeFilialCompra", resp);
  }
};

export default { namespaced: true, state, mutations, getters, actions };
